/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSyncStatus.defs.js'
export * as $defs from './getSyncStatus.defs.js'
